// extracted by mini-css-extract-plugin
export default {"pagination":"search-result-pagination_pagination__2Ttx8","showing":"search-result-pagination_showing__TZjd9","pages":"search-result-pagination_pages__u++sQ"};